import { FormRenderer } from '../renderers/form-renderer';
import type { FormFieldSchema } from '../types';

interface ViewTabProps {
  fields: FormFieldSchema[];
  formValues: Record<string, unknown>;
  onGetFile?: (fileId: number) => Promise<{ fileName: string; fileType: string; viewUrl?: string }>;
}

export function ViewTab({ fields, formValues, onGetFile }: ViewTabProps) {
  return (
    <div className="max-w-md mx-auto">
      <FormRenderer fields={fields} mode="view" values={formValues} onGetFile={onGetFile} />
    </div>
  );
}
